<div class="page-center">
  <p-card class="otp-card text-center" header="Authenticator Verification">
    <p>Enter the code from your authenticator app</p>
    <div class="otp-container">
      <div class="otp-inputs">
        <div *ngFor="let digit of otpArray; let i = index" class="otp-box" [class.active]="i === currentIndex"
          (click)="focusHiddenInput()">
          {{ digit }}
        </div>
        <input #hiddenInput type="text" inputmode="numeric" maxlength="6" autocomplete="one-time-code"
          class="hidden-input" (input)="onOtpChange($event)" (keydown)="onKeyDown($event)" (paste)="onPaste($event)" />
      </div>
      <div><a class="btn text-primary" (click)="goTo()">Authentication Setup</a></div>
    </div>
  </p-card>
</div>